import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const OptionsStatusProcessContext = createContext();

export const useOptionsStatusProcess = () => {
    const context = useContext(OptionsStatusProcessContext);
    if (!context) {
        throw new Error('useOptionsStatusProcess debe estar dentro del proveedor OptionsStatusProcessContext')
    }
    return context;
};

export const OptionsStatusProcessContextProvider = ({ children }) => {
    const [optionsStatusProcess, setOptionsStatusProcess] = useState([])
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getOptionsStatusProcess = async () => {
        const { error, data } = await supabase
            .from('status_options')
            .select('id, name')
            .order('name', { ascending: true })
        if (error) throw (error.message)
        setOptionsStatusProcess(data)
    }

    const getOptionsStatus = async (id) => {
        const { error, data } = await supabase
            .from('status_options')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    // const createSpecialty = async (formData) => {
    //     const { error, status, statusText } = await supabase
    //         .from('optionsStatusProcess')
    //         .insert(formData)
    //         .select()
    //     if (status !== 201) return {
    //         title: statusText,
    //         msg: error.message + " Code:[" + error.code + "]",
    //         icon: 'error',
    //         code: status
    //     }
    //     await getoptionsStatusProcess()
    //     setModal(true)
    //     return {
    //         title: statusText,
    //         msg: "Registro creado correctamente",
    //         icon: 'success',
    //         code: status
    //     }
    // }

    // const updateSpecialty = async (formData, id) => {
    //     try {
    //         const { error, status, statusText } = await supabase
    //             .from('optionsStatusProcess')
    //             .update(formData)
    //             .eq('id', id)
    //             .select()
    //         if (status !== 200) return {
    //             title: statusText,
    //             msg: error.message + " Code:[" + error.code + "]",
    //             icon: 'error'
    //         }
    //         await getoptionsStatusProcess()
    //         setModal(true)
    //         return ({
    //             title: statusText,
    //             msg: 'Registro actualizado correctamente',
    //             icon: 'success'
    //         })
    //     } catch (e) {
    //         console.error(e)
    //     }
    // }


    return (
        <OptionsStatusProcessContext.Provider value={{
            optionsStatusProcess,
            modal,
            getOptionsStatusProcess,
            getOptionsStatus,
            // createSpecialty,
            // updateSpecialty,
            getModal
        }}>
            {children}
        </OptionsStatusProcessContext.Provider>
    )
}